import { Box, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material'
import { CardActionsWrapper } from '../Styled/Styled'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

export const ErrorCard = ({ title, message }: { title: string; message: string }): JSX.Element => (
  <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ p: 3 }}>
    <Grid item xs={12}>
      <Card>
        <CardHeader title={<Typography variant="h3">{title}</Typography>} />
        <CardContent>
          <CardActionsWrapper
            sx={{
              display: { xs: 'block', md: 'flex' },
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Box sx={{ mt: { xs: 2, md: 0 } }}>
              <WarningAmberIcon></WarningAmberIcon>
              &nbsp;
              <Typography variant="subtitle2" component="span" sx={{ verticalAlign: 'top' }}>
                {message}
              </Typography>
            </Box>
          </CardActionsWrapper>
        </CardContent>
      </Card>
    </Grid>
  </Box>
)
